import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import inventarioService from "../../../service/logistica/inventarioService";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import GraficoValorInventario from "./GraficoValorInventario";
import GraficoCategoriaInventario from "./GraficoCategoriaInventario";
import GraficoRotacionInventario from "./GraficoRotacionInventario";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";

const TEXTO_PERIODO_ANTERIOR = "vs periodo anterior";

function filtroInicial() {
    return {
        anioInicio: global.fetchCurrentYear(),
        mesInicio: global.fetchCurrentMonth(),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth(),
        flagNotaVenta: false,
    };
}

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        // Por defecto el periodo es el mes actual (inicio = fin); con eso, el
        // backend devuelve el valor de inventario por dia. Si el rango abarca
        // mas de un mes, lo devuelve por mes.
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter: filtroInicial(),
            dashboard: buildDashboardData(null),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = filtroInicial();
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({
            loading: true,
        });
        const response = await inventarioService.dashboardInventario(filter);
        this.setState({
            dashboard: buildDashboardData(response),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda } = this.state;
        const { kpis, valorInventario, categorias, rotacion } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        const valor = valorInventario[clave];

        return (
            <div className="dashboard-inventario">
                <Header
                    title="Dashboard Resumen Inventario"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="inv-moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="inv-kpi-row">
                        <KpiCard
                            icon="code-sandbox"
                            iconColor="#2563eb"
                            iconBackground="#e8f0fe"
                            label="Productos Totales"
                            value={formatNumber(kpis.productosTotales.valor, 0)}
                            tendenciaDireccion={kpis.productosTotales.tendenciaDireccion}
                            tendenciaValor={`${formatNumber(Math.abs(kpis.productosTotales.tendenciaPct))}%`}
                            tendenciaTexto={TEXTO_PERIODO_ANTERIOR}
                        />
                        <KpiCard
                            icon="inbox"
                            iconColor="#16a34a"
                            iconBackground="#e3f6ea"
                            label="Productos con Stock"
                            value={formatNumber(kpis.productosConStock.valor, 0)}
                            tendenciaDireccion={kpis.productosConStock.tendenciaDireccion}
                            tendenciaValor={`${formatNumber(Math.abs(kpis.productosConStock.tendenciaPct))}%`}
                            tendenciaTexto={TEXTO_PERIODO_ANTERIOR}
                        />
                        <KpiCard
                            icon="warning"
                            iconColor="#ea580c"
                            iconBackground="#fff1e6"
                            label="Productos con Stock Bajo"
                            value={formatNumber(kpis.productosStockBajo.valor, 0)}
                            valueColor="#ea580c"
                            tendenciaDireccion={kpis.productosStockBajo.tendenciaDireccion}
                            tendenciaValor={`${formatNumber(Math.abs(kpis.productosStockBajo.tendenciaPct))}%`}
                            tendenciaTexto={TEXTO_PERIODO_ANTERIOR}
                        />
                        <KpiCard
                            icon="close-circle"
                            iconColor="#dc2626"
                            iconBackground="#fdecec"
                            label="Productos Sin Stock"
                            value={formatNumber(kpis.productosSinStock.valor, 0)}
                            valueColor="#dc2626"
                            tendenciaDireccion={kpis.productosSinStock.tendenciaDireccion}
                            tendenciaValor={`${formatNumber(Math.abs(kpis.productosSinStock.tendenciaPct))}%`}
                            tendenciaTexto={TEXTO_PERIODO_ANTERIOR}
                        />
                    </div>

                    <Row gutter={16} type="flex">
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Inventario por Categoría">
                                <div className="inv-chart-panel-centrado">
                                    <GraficoCategoriaInventario datos={categorias.datos} total={categorias.total} />
                                </div>
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel
                                title="Rotación de Inventario"
                                value={formatNumber(rotacion.valor, 2)}
                                valueSuffix="veces"
                                tendenciaDireccion={rotacion.tendenciaDireccion}
                                tendenciaValor={formatNumber(Math.abs(rotacion.tendenciaValor), 2)}
                                tendenciaTexto="vs mes anterior"
                            >
                                <GraficoRotacionInventario meses={rotacion.meses} valores={rotacion.valores} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <ChartPanel
                                title="Valor Total de Inventario"
                                value={formatCurrency(valor.valor, moneda)}
                                tendenciaDireccion={valor.tendenciaDireccion}
                                tendenciaValor={`${formatNumber(Math.abs(valor.tendenciaPct))}%`}
                                tendenciaTexto={TEXTO_PERIODO_ANTERIOR}
                            >
                                <GraficoValorInventario
                                    timeLine={valorInventario.timeLine}
                                    serie={valor.serie}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
